export enum Permissions {
  // AdminPermission
  AdminRead = 'AdminRead',
  AdminWrite = 'AdminWrite',

  // AuditPermission
  AuditRead = 'AuditRead',
  AuditWrite = 'AuditWrite',
  AuditCreate = 'AuditCreate',

  // DraftPermission
  DraftRead = 'DraftRead',
  DraftWrite = 'DraftWrite',
  DraftCreate = 'DraftCreate',

  // GroupPermission
  GroupRead = 'GroupRead',
  GroupWrite = 'GroupWrite',
  GroupCreate = 'GroupCreate',

  // MarketingPermission
  EngagementCenterRead = 'EngagementCenterRead',

  MarketingCampaignExcludeWrite = 'MarketingCampaignExcludeWrite',

  // MarketingProfilePermission
  MarketingProfileBaseWrite = 'MarketingProfileBaseWrite',
  MarketingProfileBaseCreate = 'MarketingProfileBaseCreate',

  MarketingProfileCommentsRead = 'MarketingProfileCommentsRead',
  MarketingProfileCommentsWrite = 'MarketingProfileCommentsWrite',
  MarketingProfileCommentsCreate = 'MarketingProfileCommentsCreate',

  MarketingProfileDeleteWrite = 'MarketingProfileDeleteWrite',

  MarketingProfileListRead = 'MarketingProfileListRead',

  MarketingProfileRetentionRead = 'MarketingProfileRetentionRead',
  MarketingProfileRetentionWrite = 'MarketingProfileRetentionWrite',
  MarketingProfileRetentionCreate = 'MarketingProfileRetentionCreate',

  MarketingProfileRegistrationRead = 'MarketingProfileRegistrationRead',
  MarketingProfileRegistrationWrite = 'MarketingProfileRegistrationWrite',
  MarketingProfileRegistrationCreate = 'MarketingProfileRegistrationCreate',

  MarketingProfilePreferencesRead = 'MarketingProfilePreferencesRead',
  MarketingProfilePreferencesWrite = 'MarketingProfilePreferencesWrite',
  MarketingProfilePreferencesCreate = 'MarketingProfilePreferencesCreate',

  // MemberPermission
  MemberRead = 'MemberRead',
  MemberWrite = 'MemberWrite',
  MemberCreate = 'MemberCreate',

  // ReportPermission
  ReportEligibilityRead = 'ReportEligibilityRead',

  // ResellerPermission
  ResellerRead = 'ResellerRead',
  ResellerWrite = 'ResellerWrite',
  ResellerCreate = 'ResellerCreate',

  // RolePermission
  RoleRead = 'RoleRead',
  RoleWrite = 'RoleWrite',
  RoleCreate = 'RoleCreate',

  // SystemActivityLogPermission
  SystemActivityLogRead = 'SystemActivityLogRead',

  // UserPermission
  UserRead = 'UserRead',
  UserWrite = 'UserWrite',
  UserCreate = 'UserCreate'
}
